import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../auth-service/login.service';
import { ToastrService } from 'ngx-toastr';
import { LaguageService } from 'src/app/laguage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  error: any;
  isLoading: boolean = false;
  showPassword: boolean = false;
  currentLang: any;
  
  loginForm = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, [Validators.required]),
  })

  constructor(private _loginService: LoginService, private _Router: Router,
    private toasterService: ToastrService, private _lang: LaguageService) { 
    this.currentLang = this._lang.getValue();

    }

  showHidePassword() : void{
    this.showPassword = !this.showPassword;
  }

  submitLoginForm(loginForm: FormGroup) {
    this.isLoading = true;
    this._loginService.login(loginForm.value).subscribe(
      (response: any) => {
        localStorage.setItem('userToken', response.data[0].access_token);
        localStorage.setItem('refresh_token', response.data[0].refresh_token)
        this._loginService.saveCurrentUser();
        this._loginService.saveUserData();
        this.toasterService.success('success login');
        this.isLoading = false;
        this._Router.navigate(['./healthcare']);
      },
      (err) => {
        this.isLoading = false;
        this.error = err.error.data
      },
    );
  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  onFocus(): void {
    this.error = false;
  }

  ngOnInit(): void {
    this._loginService.currentUser.subscribe(() => {
      if (this._loginService.currentUser.getValue() != null) {
        this._Router.navigate(['/healthcare']);
      }
      else {
        this._Router.navigate(['/login']);
      }
    })
  }

}